import React, { useState, useRef, useEffect} from 'react';
import Input from '../../../../Components/Input';
import TextInput from '../../../../Components/TextInput';
import DateInput from '../../../../Components/DateInput';
import search from '../../../../Assets/Icons/search.png';
import Dropdown from '../../../../Components/Dropdown';
import GenerateProgressReportController from '../../../Controllers/AdminScreens/ProgressCard/GenerateProgressReportController';
import Loader from '../../../../Components/Loader';

const GenerateProgressReports = () => {
    const{
        reportName,
        setReportName,
        clientName,
        setClientName,
        status,
        setStatus,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        generateReportSuccess,
        generateReportError,
        generateReportLoading,
        handleSearchEmployee,
        employeesListLoading,
        clientSearchError,
        employeeList,
        error,
        selectedEmployee,
        handleSearchInputChange,
        handleSelectedEmployee,
        searchUser,
        generateProgressReport,
        resetFilter,
        reportNameError
    } = GenerateProgressReportController();

   

    const deliveryTypeOptions = [{ label: "Schedule Report", value: 'schedule_report' }];
    // const roleTypes = [{ label: 'Type 1', value: 'Type 1' }, { label: 'Type 2', value: 'Type 2' }];
    const statusOptions = [{ label: 'Attended', value: 1}, { label: 'Not Attended', value: 2 },{ label: 'Pending', value: 3 }];

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div style={{ width: '93%', margin: 'auto' }}>
                <h3 style={styles.header}>
                    <div style={styles.headerContainer}>
                        <span>Progress Card - Reports</span>
                    </div>
                </h3>
            </div>
            <div className="tasksScreen-main-content" style={{ width: 'unset' }}>
                <div className="tasksScreen-tasks-container" >
                    <div className="tasksScreen-tasks-header">
                        <h2 className="tasksScreen-tasks-title">Generate Reports</h2>
                    </div>
                    <hr className="footer-divider" />
                    <div style={{width:'220px'}}>
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["Report Name"] = el)}
                        isOpen={openDropdown === "Report Name"}
                        toggleDropdown={() => toggleDropdown("Report Name")}
                        label="Report Name"
                        options={deliveryTypeOptions}
                        value={reportName}
                        onChange={setReportName}
                        searchBoxWidth={200}
                        errorMessage={reportNameError}
                    />
                    </div>
                    <div className="filter-field" style={{ paddingBottom: '10px',marginTop:'10px',marginBottom:'5px',width:'300px' }}>
                                    <label style={{ fontSize: '12px', color: '#343C44' }}>Client Name</label>
                                    <TextInput
                                        type="text"
                                        placeholder="Client Name"
                                        value={searchUser}
                                        onChange={(e) => handleSearchInputChange(e.target.value)}
                                        onRightClick={handleSearchEmployee}
                                        // searchBoxWidth={280}
                                        right={
                                            employeesListLoading ? (
                                                <Loader loading={employeesListLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                                            ) : (
                                                <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                                            )
                                        }
                                        style={{ padding: '20px 10px' }}
                                        errorMessage={error || clientSearchError}
                                    />
                                    {employeeList?.length > 0 && (
                                        <ul style={styles.dropdownList}>
                                            {employeeList?.map((employee, index) => (
                                                <li
                                                    key={employee?.client_id}
                                                    onClick={() => handleSelectedEmployee(employee)}
                                                    style={{
                                                        ...styles.dropdownItem,
                                                        borderBottom: index !== employeeList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                                    }}
                                                >
                                                    {employee?.client_name}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                    {/* <div style={{ width:'300px'}}>
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["Select Role"] = el)}
                        isOpen={openDropdown === "Select Role"}
                        toggleDropdown={() => toggleDropdown("Select Role")}
                        label="Select Role"
                        options={roleTypes}
                        value={roleType}
                        onChange={setRoleType}
                        isMulti
                        // searchBoxWidth={330}
                    />
                    </div> */}
                    <div style={{marginBottom:'10px',marginTop:'10px', width:'220px'}}>
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["Select Status"] = el)}
                        isOpen={openDropdown === "Select Status"}
                        toggleDropdown={() => toggleDropdown("Select Status")}
                        label="Select Status"
                        options={statusOptions}
                        value={status}
                        onChange={setStatus}
                        // searchBoxWidth={200}
                    />
                    </div>
                    <div style={{marginTop:'10px'}}>
                        <div className="filter-field">
                            <label>Period</label>
                            <DateInput
                                value={startDate || ""}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <span style={{ margin: '0 10px' }}>-</span>
                        <div className="filter-field">
                            {/* <label>Period</label> */}
                            <DateInput
                                value={endDate || ""}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="button-container" style={{ gap: "10px" }}>
                        <button className="add-client-button" onClick={generateProgressReport}
                        style={{
                            cursor: generateReportLoading ? "not-allowed" : "pointer",
                            opacity: generateReportLoading ? 0.6 : 1,
                            pointerEvents:generateReportLoading? 'none' :'auto',
                            gap: '5px',
                            display:'flex'
                        }}
                        disabled={generateReportLoading}>
                            
                            {generateReportLoading && (
                                    <Loader loading={generateReportLoading} color={'var(--background-color)'} size="small" />
                                )}
                                <span>Generate</span>
                        </button>
                        <button style={styles.cancelButton} onClick={resetFilter}>
                            Cancel
                        </button>
                        {generateReportError && <div style={{fontSize:'12px', color:'red', marginTop:'5px'}}>{generateReportError} </div>}
                        {generateReportSuccess && <div style={{fontSize:'12px', color:'green', marginTop:'5px'}}>{generateReportSuccess} </div>}
                    </div>
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

const styles = {
    header: {
        fontSize: "22px",
        color: "#060606",
        marginBottom: "10px",
        fontWeight: 500,
        // fontFamily: 'Montserrat',
        //   marginLeft:'20px'
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center', // Vertically align items
    },
    cancelButton: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    },
    dropdownList: {
        position: 'absolute',
        top: '85%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0, // Remove default padding
        margin: 0, // Remove default margin
        listStyleType: 'none', // Remove the dots
    },

    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee', // Default for all items
        backgroundColor: '#fff',
        hover: {
            backgroundColor: '#f0f0f0',
        },
    },
};

export default GenerateProgressReports;
